import AddIcon from '@mui/icons-material/Add'
import { Button, Stack } from '@mui/material'
import { useGetAllException } from '@src/api/exception-api'
import { useGetAllPerson } from '@src/api/person-api'
import ApprovedRemoteExceptionsAddDialog from '@src/components/Exception/ApprovedRemoteExceptionsAddDialog'
import ExceptionDataTable from '@src/components/Exception/ExceptionDataTable'
import ExceptionPersonFilterAutoComplete from '@src/components/Exception/ExceptionPersonFilterAutoComplete'
import PageContainer from '@src/components/Layout/PageContainer'
import PageHeader from '@src/components/Layout/PageHeader'
import { ApprovedRemoteExceptionsQueryParams, PaginationParams } from '@src/types/ApprovedRemoteExceptions'
import { Person } from '@src/types/Person'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const ExceptionPage = () => {
  const [paginationModel, setPaginationModel] = useState<PaginationParams>({ limit: 100, offset: 0 })
  const [selectedPersonFilter, setSelectedPersonFilter] = useState<Person | null>(null)

  const queryParams: ApprovedRemoteExceptionsQueryParams = {
    personId: selectedPersonFilter ? selectedPersonFilter.id : null,
    limit: paginationModel.limit ?? 100,
    offset: paginationModel.offset ?? 0,
  }

  const [persons, isFetchingPersons] = useGetAllPerson()
  const [exceptions, isFetchingExceptions] = useGetAllException(queryParams)

  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const onCloseAdd = () => setOpen(false)

  const onPersonFilterChange = (person: Person | null) => {
    setSelectedPersonFilter(person)
  }

  const onPaginationModelChange = (model: PaginationParams) => {
    setPaginationModel(model)
  }

  return (
    <>
      <PageHeader
        title={t('breadcrumbs.approvedRemoteExceptions')}
        breadcrumbs={{
          path: [{ href: '/exceptions', label: t('breadcrumbs.approvedRemoteExceptions') }],
        }}
        actions={
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
            <ExceptionPersonFilterAutoComplete
              persons={persons}
              onPersonChange={onPersonFilterChange}
              selectedPerson={selectedPersonFilter}
              sx={{ width: 300 }}
            />
            <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => setOpen(true)}>
              {t('common.add')}
            </Button>
          </Stack>
        }
      />
      <PageContainer>
        <ApprovedRemoteExceptionsAddDialog
          open={open}
          onCloseAdd={onCloseAdd}
          persons={persons}
          queryParams={queryParams}
        />
        <ExceptionDataTable
          persons={persons}
          exceptions={exceptions}
          paginationParams={paginationModel}
          onPaginationParamsChange={onPaginationModelChange}
          queryParams={queryParams}
          isFetching={isFetchingPersons || isFetchingExceptions}
        />
      </PageContainer>
    </>
  )
}

export default ExceptionPage
